import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    boxList: {
      background: theme.palette.background.default,
      borderRadius: "4px",
      width: "100%",
      marginTop: "0.8rem",
      display: "flex",
      flexDirection: "column",
      padding: "6px 14px 20px"
    },
    info: {
      display: "flex"
    },
    headerTxt: {
      marginBottom: 12,
      color: theme.palette.info.dark
    },
    icon: {
      marginRight: "0.6rem",
      "& path": {
        stroke: theme.palette.info.dark
      }
    },
    caption: {
      color: theme.palette.grey[700]
    },
    chipBox: {
      height: "200px",
      overflowY: "auto",
      background: theme.palette.background.default,
      borderRadius: "8px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "0.8rem 1.6rem",
      marginTop: "0.8rem",

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#D9D9D9",
        border: "5px solid transparent",
        borderRadius: 9,
        backgroundClip: "content-box"
      },
      "&::-webkit-scrollbar": {
        width: 16
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#FFFFFF",
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: 0
      },
      "&::-webkit-scrollbar-button:vertical:increment": {
        display: "none"
      },
      "&::-webkit-scrollbar-button:vertical:decrement": {
        display: "none"
      }
    },
    chipPaper: {
      boxShadow: "none",
      background: theme.palette.background.default,
      width: "100%",
      padding: 0,
      margin: 0,
      display: "flex",
      flexWrap: "wrap",
      listStyle: "none"
    },
    chipLi: {
      width: "100%"
    },
    chipText: {
      color: theme.palette.info.dark,
      marginBottom: 10
    },
    chip: {
      cursor: "pointer",
      margin: "0.5rem 0",
      borderRadius: 4,
      justifyContent: "space-between",
      width: "100%",
      height: 24,
      "& .MuiChip-label": {
        color: theme.palette.grey[900],
        fontWeight: 400,
        fontSize: "1.2rem",
        lineHeight: "18px"
      }
    },
    deleteIcon: {
      marginRight: "1.4rem",
      width: "1rem"
    }
  }),
  {
    name: "MultipleAutocompleteTextInput"
  }
);

export default useStyles;
